import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  ChevronRight,
  ChevronLeft,
  MapPin,
  DollarSign,
  Wallet,
  IndianRupee,
} from "lucide-react"; 
import { Link } from "react-router-dom";
import FormBox from "../modal/FormBox";

const HotProjects = ({ HotProjectsData, formdata }) => {
  const [itemIndex, setItemIndex] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [currentFormData, setCurrentFormData] = useState(null); // State to hold selected form data

  const caption = HotProjectsData.caption;

  const handleOpenForm = (formdata) => {
    setCurrentFormData(formdata); // Set the selected form data
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setCurrentFormData(null); // Clear the form data on close
  };

  const openProject = (url) => {
    window.location.href = `${url}`;
  };

  const NextArrowTwo = ({ onClick }) => (
    <div
      className="bg-gray-400 bg-opacity-70 absolute cursor-pointer z-10 right-0 
      top-1/2 transform -translate-y-1/2 p-2 rounded-full hover:bg-opacity-90 transition-colors duration-300"
      onClick={onClick}
    >
      <ChevronRight size={24} color="white" />
    </div>
  );

  const PrevArrowTwo = ({ onClick }) => (
    <div
      className="bg-gray-400 bg-opacity-70 absolute cursor-pointer z-10 left-0 top-1/2 transform -translate-y-1/2 p-2 rounded-full hover:bg-opacity-90 transition-colors duration-300"
      onClick={onClick}
    >
      <ChevronLeft size={24} color="white" />
    </div>
  );

  const settingsTwo = {
    infinite: true,
    lazyLoad: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    nextArrow: <NextArrowTwo />,
    prevArrow: <PrevArrowTwo />,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    beforeChange: (current, next) => setItemIndex(next),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };

  return (
    <div
      className="hot-projects-slider bg-cover bg-center bg-gray-500 flex flex-col justify-center 
      items-center text-center text-white relative"
      style={{ backgroundImage: `url(${HotProjectsData.background})` }}
    >
      <div className="mt-2">
        <h3 className="section-title__title mt-10">{HotProjectsData.title}</h3>
        <p className="text-gray-800">{caption}</p>
      </div>

      <div className="Desktop container mx-auto px-4 md:mt-10 -mt-10">
        <Slider {...settingsTwo} className="flex">
          {HotProjectsData.properties.map((item, idx) => (
            <div
              key={idx}
              className={`transition-all duration-300 ease-in-out no-underline mb-10 ${idx === itemIndex
                  ? "scale-105 opacity-100"
                  : "scale-95 opacity-75"
                }`}
            >
              <div
                className="w-full h-[440px] border sm:w-[90%] md:w-[85%] mx-auto lg:w-[80%] xl:w-[75%]
                rounded-xl text-center bg-white transition-colors duration-300 ease-in-out shadow-lg  pb-2
                  flex flex-col shadow-3xl-white"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-[65%] rounded-t-xl shadow-3xl-white cursor-pointer"
                  onClick={() => item.url ? openProject(item.url) : handleOpenForm(item.form)}
                />
                <div className="px-4 mt-2 flex flex-col justify-between">
                  <div className="flex flex-col justify-center h-[60px]">
                    <h3 className="text-[18px] text-black text-left leading-[18px]">
                      {item.title}
                    </h3>
                  </div>
                  <div className="flex">
                    <MapPin size={18} className="text-gray-800" />
                    <h6 className="text-[12px] text-gray-800 ml-1">
                      {item.address}
                    </h6>
                  </div>
                  <div className="flex">
                    {HotProjectsData.location !== "India" ? (
                      <Wallet size={18} className="text-black" />
                    ) : (
                      <IndianRupee size={18} className="text-gray-800" />
                    )}
                    <h6 className="text-[12px] text-gray-800 ml-1">
                      {item.price}
                    </h6>
                  </div>
                  <div className="mt-2 ml-1 flex justify-left">
                    <button
                      onClick={() => handleOpenForm(item.form)} // Pass form data here
                      className="bg-gray-600 text-white text-[10px] w-[100px] h-[25px] px-2 rounded-lg hover:text-gray-800
                      hover:border-black"
                    >
                      View More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
        {/* Pop up Form Start */}
        {showForm && formdata && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg p-6 shadow-lg relative w-full max-w-lg">
              <button
                onClick={handleCloseForm}
                className="absolute top-2 right-2 text-black bg-gray-200 rounded-full p-2 hover:bg-gray-300"
              >
                ✕
              </button>
              {/* Pass the selected form data */}
              <FormBox onClose={handleCloseForm} formdata={formdata} />
            </div>
          </div>
        )}
        {/* Pop up End */}
      </div>
    </div>
  );
};

export default HotProjects;
